import styled from 'styled-components'
import { FlexDiv, A } from 'components/generic/HomePageComponents'

export const ExtraBreakpointDiv = styled(FlexDiv)`
flex-direction: column;
height: ${(props) => props.height};
flex-wrap: wrap;
@media (max-width: 375px) {
    height: ${(props) => props.breakpointHeight};
    align-items: center;
}
`

export const SectionA = styled(A)`
color: ${(props) => props.theme.colors.white};
font-size: 15px;
line-height: 21.5px;
text-decoration: none;
:hover {
    cursor: pointer;
    text-decoration: underline;
}
`

export const FooterNavItemsContainer = styled.div`
display: flex;
${(props) => (props.show ? `display: block;` : ` display: none;`)}
`
